<script lang="ts">
	// Genuine shadcn-svelte Select.Trigger (bits-ui), RESTYLED to price-check tokens.
	// Icons use lucide-core via our Icon wrapper (not @lucide/svelte). NO arbitrary
	// `[..]` values or animation utilities.
	import { Select as SelectPrimitive } from "bits-ui";
	import { cn, type WithoutChild } from "../../../utils.js";
	import { ChevronDown } from "lucide";
	import Icon from "../../../icon.svelte";

	let {
		ref = $bindable(null),
		class: className,
		children,
		size = "default",
		...restProps
	}: WithoutChild<SelectPrimitive.TriggerProps> & {
		size?: "sm" | "default";
	} = $props();
</script>

<SelectPrimitive.Trigger
	bind:ref
	data-slot="select-trigger"
	data-size={size}
	class={cn(
		"flex w-fit items-center justify-between gap-1.5 whitespace-nowrap rounded-md border border-border bg-surface px-2.5 py-2 text-sm text-ink outline-none transition-colors select-none data-[size=default]:h-9 data-[size=sm]:h-8 data-placeholder:text-muted focus-visible:border-brand focus-visible:ring-2 focus-visible:ring-brand disabled:cursor-not-allowed disabled:opacity-55 [&_svg]:pointer-events-none [&_svg]:shrink-0",
		className
	)}
	{...restProps}
>
	{@render children?.()}
	<Icon icon={ChevronDown} size={16} class="text-muted" />
</SelectPrimitive.Trigger>
